<template>
  <DialogSubscriberSlideTemplate
    color="#dcfaea"
    :class="{ loaded: loaded }"
    :title="title"
    :description="description"
  >
    <template #image>
      <ImgLoad
        class="img"
        :alt="description"
        :src="src"
        :srcset="srcset"
        :width="width"
        :height="height"
        effect="scale-and-fade"
        @load="handleLoaded"
      />
    </template>
  </DialogSubscriberSlideTemplate>
</template>
<script setup lang="ts">
interface Props {
  title: string;
  description: string;
  src: string;
  srcset: string;
  width: number;
  height: number;
}

defineProps({
  title: null,
  description: null,
  src: null,
  srcset: null,
  width: null,
  height: null
});

const loaded = ref<boolean>(false);

const handleLoaded = () => {
  loaded.value = true;
};
</script>
